<!--<div id="desktop">-->
<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12">
      <br /><br />
      <h4 style="font-weight:bold; text-decoration:underline; text-align:center">DIRECT PURCHASER TURKEY ANTITRUST CLAIM FORM</h4>
      <h5 style="text-decoration:underline; text-align:center">UNITED STATES DISTRICT COURT FOR THE NORTHERN DISTRICT OF ILLINOIS</h5>

      <br />
      Our records indicate you may be a member of the Certified Class in this action for the Settlements with Defendants Agri Stats,
      Inc. (“Agri Stats”); Cooper Farms, Inc. (“Cooper Farms”); Farbest Foods, Inc. (“Farbest”); House of Raeford Farms, Inc. (“House
      of Raeford”); Prestage Farms, Inc., Prestage Foods, Inc., and Prestage Farms of South Carolina, LLC (“Prestage” or “the Prestage
      Defendants”); Hormel Foods Corporation and Jennie-O Turkey Store, Inc. (“JOTS”); Butterball, LLC (“Butterball”); Foster Farms
      LLC and Foster Poultry Farms LLC (“Foster Farms” or “the Foster Farms Defendants”); and Perdue Farms, Inc. and Perdue Foods LLC
      (“Perdue” or “the Perdue Defendants”).<br /><br />

      The Certified Class, subject to certain exclusions, is defined as “All persons and entities who directly purchased fresh or frozen,
      uncooked turkey breast, ground turkey, or whole bird turkey products (“Class Products”) from Defendants in the United States from
      January 1, 2010, through December 31, 2016 (“Class Period”). For purposes of the Certified Class, the Class Products include fresh
      or frozen, uncooked turkey breast, ground turkey, or whole bird turkey products. Turkey breast products do not include: turkey
      breasts used to make ground turkey, turkey breast tenderloins, organic turkey breast products, No Antibiotics Ever (“NAE”) or
      Antibiotic-Free (“ABF”) turkey breast products, and cooked or ready-to-eat (“RTE”) turkey breast products. Ground turkey products
      do not include: ground turkey products made from turkey breasts; ground turkey products made from turkey wings; burgers, sausages,
      and patties; organic ground turkey products NAE or ABF ground turkey products; and cooked or RTE ground turkey products. Whole bird
      turkey products do not include: organic turkey whole bird products, NAE or ABF turkey whole bird products, and cooked or RTE turkey
      whole bird products.<br /><br />

      The Defendants in this lawsuit include Butterball; Cargill, Inc., Cargill Protein – North America f/k/a Cargill Meat Solutions
      Corporation; Cooper Farms; Farbest Foods; Foster Farms; JOTS; House of Raeford; Perdue; Prestage; Tyson Foods, Inc., Tyson Fresh
      Meats, Inc., Tyson Prepared Foods, Inc., Hillshire Brands; and Agri Stats. Defendants’ “co-conspirators” include Dakota Provisions,
      LLC; Kraft Heinz Company; Kraft Foods Group Brands LLC; Michigan Turkey Producers LLC; Norbest LLC; and West Liberty Foods LLC.<br /><br />

      The Court has now approved a claims process to distribute the net Certified Class settlement proceeds from the settlements with
      Cooper Farms, Farbest Foods, House of Raeford, Prestage, JOTS, and Butterball to eligible Certified Class members. Any attorneys’
      fees, expenses, notice and administration costs, and service awards approved by the Court will be deducted from the combined proceeds
      from these Settlements before they are paid to qualified claimants. The net settlement proceeds will be distributed to eligible
      Certified Class Members who file valid claims. Payments to qualified claimants from the net Certified Class settlement proceeds
      will be calculated based on the proportional (or pro rata) amount of their approved Turkey Certified Class products during the
      Class Period compared to the combined Turkey purchases of all participating Certified Class members. <b>
        To be eligible to receive
        a payment from the Certified Class settlement proceeds, you must submit this Claim Form to the mailing address listed at the top
        of this form (postmarked) or on the Settlement Website www.TurkeyLitigation.com by October 30, 2026, <i>
          even if you previously
          submitted a claim form for the Tyson and Cargill Settlements
        </i>
      </b>.<br /><br />

      You can complete and submit this form by mail, or you may use your Unique ID and pin numbers listed at the top of this page to
      log in at www.TurkeyLitigation.com, where you can submit a claim and review your purchase information electronically. If your
      organization received more than one notice, you only need to file one Claim Form for each Unique ID.<br /><br />

      <h4 style="font-weight:bold; text-align:center">Review your purchase information</h4><br /><br />

      The total award amount you receive will be calculated based on the purchase information from records available from Defendants
      and updated based on any audits for information obtained during the settlement distribution process.
      <b><i>Please note that Defendant House of Raeford did not provide any purchase data</i></b>.
      Your total known Settlement qualifying purchases from Defendants (except for House of Raeford) for the period between January 1,
      2010 through December 31, 2016 are ${{au.purchaseNetTotal}}. Details about the amount of your qualifying purchases are on page 3.
      <b><i>To include purchases from Defendant House of Raeford with your claim</i></b>, you must submit the Purchase Audit Request Form and provide
      the requested information.<br /><br /><br/>

      <h4 style="font-weight:bold; text-align:center">Agree/Disagree</h4><br /><br />

   


    </div>
  </div>
  <div class="row mt-5">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <b><u>Unique ID:</u></b>&nbsp;&nbsp;&nbsp;{{au.uniqueId}}<br /><br />
      <b><u>Pin:</u></b>&nbsp;&nbsp;&nbsp;{{au.pin}}<br /><br />

      <table class="table table-bordered table-striped" #listofInformation>
        <thead>
          <tr>
            <th>DEFENDANT</th>
            <th>
              2010
            </th>
            <th>
              2011
            </th>
            <th>
              2012
            </th>
            <th>
              2013
            </th>
            <th>
              2014
            </th>
            <th>
              2015
            </th>
            <th>
              2016
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="font-weight:bold">Butterball</td>
            <td>${{au.butterball2010}}</td>
            <td>${{au.butterball2011}}</td>
            <td>${{au.butterball2012}}</td>
            <td>${{au.butterball2013}}</td>
            <td>${{au.butterball2014}}</td>
            <td>${{au.butterball2015}}</td>
            <td>${{au.butterball2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Cargill</td>
            <td>${{au.cargill2010}}</td>
            <td>${{au.cargill2011}}</td>
            <td>${{au.cargill2012}}</td>
            <td>${{au.cargill2013}}</td>
            <td>${{au.cargill2014}}</td>
            <td>${{au.cargill2015}}</td>
            <td>${{au.cargill2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Cooper Farms</td>
            <td>${{au.cooperFarms2010}}</td>
            <td>${{au.cooperFarms2011}}</td>
            <td>${{au.cooperFarms2012}}</td>
            <td>${{au.cooperFarms2013}}</td>
            <td>${{au.cooperFarms2014}}</td>
            <td>${{au.cooperFarms2015}}</td>
            <td>${{au.cooperFarms2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Farbest Foods</td>
            <td>${{au.farbestFoods2010}}</td>
            <td>${{au.farbestFoods2011}}</td>
            <td>${{au.farbestFoods2012}}</td>
            <td>${{au.farbestFoods2013}}</td>
            <td>${{au.farbestFoods2014}}</td>
            <td>${{au.farbestFoods2015}}</td>
            <td>${{au.farbestFoods2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Foster Farms</td>
            <td>${{au.fosterFarms2010}}</td>
            <td>${{au.fosterFarms2011}}</td>
            <td>${{au.fosterFarms2012}}</td>
            <td>${{au.fosterFarms2013}}</td>
            <td>${{au.fosterFarms2014}}</td>
            <td>${{au.fosterFarms2015}}</td>
            <td>${{au.fosterFarms2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Hormel</td>
            <td>${{au.hormel2010}}</td>
            <td>${{au.hormel2011}}</td>
            <td>${{au.hormel2012}}</td>
            <td>${{au.hormel2013}}</td>
            <td>${{au.hormel2014}}</td>
            <td>${{au.hormel2015}}</td>
            <td>${{au.hormel2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Perdue</td>
            <td>${{au.perdue2010}}</td>
            <td>${{au.perdue2011}}</td>
            <td>${{au.perdue2012}}</td>
            <td>${{au.perdue2013}}</td>
            <td>${{au.perdue2014}}</td>
            <td>${{au.perdue2015}}</td>
            <td>${{au.perdue2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Prestage</td>
            <td>${{au.prestage2010}}</td>
            <td>${{au.prestage2011}}</td>
            <td>${{au.prestage2012}}</td>
            <td>${{au.prestage2013}}</td>
            <td>${{au.prestage2014}}</td>
            <td>${{au.prestage2015}}</td>
            <td>${{au.prestage2016}}</td>
          </tr>
          <tr>
            <td style="font-weight:bold">Tyson</td>
            <td>${{au.tyson2010}}</td>
            <td>${{au.tyson2011}}</td>
            <td>${{au.tyson2012}}</td>
            <td>${{au.tyson2013}}</td>
            <td>${{au.tyson2014}}</td>
            <td>${{au.tyson2015}}</td>
            <td>${{au.tyson2016}}</td>
          </tr>
        </tbody>
      </table>
      <br /><br />
    </div>
    <div class="col-md-1"></div>
  </div>
  <div class="row">
    <div class="col-md-12" style="text-align:center; font-size:1.3em">
      <b><u>Purchase Total</u></b>&nbsp;&nbsp;&nbsp;${{au.purchaseNetTotal}}<br /><br />

    </div>
    </div>
  <div class="row">
    <div class="col-md-2">
    </div>
    <div class="col-md-2">
      <a style="font-weight: bold; font-size: 1.3em" href="/agree">Agree</a>
    </div>
    <div class="col-md-4">
    </div>
    <div class="col-md-4">
      <a style="font-weight: bold; font-size: 1.3em" href="/audit-request">Disagree</a>
    </div>
  </div>
  <br/><br/>
  </div>
    <!--</div>-->
    <!--<div id="mobile">
      <div class="container" style="border:1px solid #bebaba">
        <div class="row indentContent">
          <div class="col-md-12">
            <h2 class="red" id="FontTwoMobile">Contact Information</h2>
            <div>
              <p class="text-center" style="font-weight:bold;margin-top:3%">You may write to the Claims Administrator at:</p>
              <div class="row">
                <div class="col-md-12 text-center">
                  Broilers CIIPP Settlement<br />
                  Claims Administrator<br />
                  c/o A.B. Data, Ltd.<br />
                  P.O. Box 173122<br />
                  Milwaukee, WI 53217<br />
                  E-mail:  <a href="mailto:info@chickencommercialsettlement.com">info@chickencommercialsettlement.com</a><br />
                  Toll-Free Number: 1-800-983-6533<br />
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
        <br /><br />
      </div>
      <app-footer></app-footer>
    </div>-->
